import { useQuery } from '@tanstack/react-query';
import { dateUtil } from '@xtnd/web/shared';

import { reportingMatterLedgerApi } from '../api';
import { LedgerReportForm } from '../types';

export const useGenerateLegerReport = (queryParams: LedgerReportForm) => {
    const generateDateRange = queryParams.dateRange;
    const fromDate = generateDateRange.from ? dateUtil.formatDate(new Date(generateDateRange.from), dateUtil.DateFormat.ISO) : undefined;
    const toDate = generateDateRange.to ? dateUtil.formatDate(new Date(generateDateRange.to), dateUtil.DateFormat.ISO) : undefined;

    const ledgerType = queryParams.ledgerType;
    const entityId = queryParams.ledgerData;
    const runDate = queryParams.runDate ? dateUtil.formatDate(new Date(queryParams.runDate), dateUtil.DateFormat.ISO) : undefined;

    // Build queryKey only with defined values
    const queryKey = ['ledgerReport'] as (string | undefined)[];
    if (ledgerType) queryKey.push(ledgerType);
    if (entityId) queryKey.push(entityId);
    if (runDate) queryKey.push(runDate);
    if (fromDate) queryKey.push(fromDate);
    if (toDate) queryKey.push(toDate);

    return useQuery({
        queryKey,
        queryFn: () => reportingMatterLedgerApi.getLedgerReport(queryParams),
        enabled: true,
        staleTime: 2 * 60 * 1000, // 2 minutes
        gcTime: 5 * 60 * 1000, // 5 minutes
        retry: 1,
    });
};

export function useArLedgerExportCsv(params: LedgerReportForm) {
    return useQuery({
        queryKey: ['exportCsvARLedger', `type-${params.ledgerType}`, `data-${params.ledgerData}`, params] as const,
        queryFn: () => reportingMatterLedgerApi.exportCsv(params),
        enabled: false,
        staleTime: 2 * 60 * 1000, // 2 minutes
        gcTime: 5 * 60 * 1000, // 5 minutes
        retry: 0,
    });
}